import { render, staticRenderFns } from "./mainApp.vue?vue&type=template&id=46376149&scoped=true&"
import script from "./mainApp.vue?vue&type=script&lang=js&"
export * from "./mainApp.vue?vue&type=script&lang=js&"
import style0 from "./mainApp.vue?vue&type=style&index=0&id=46376149&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46376149",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VApp,VContent})
